// src/finance/format.ts
const eurFull = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

export function fmtEur(n: number): string {
  return eurFull.format(n)
}

/** Parse une saisie utilisateur en montant ≥ 0 ; accepte la virgule française. */
export function parseAmount(raw: string): number | null {
  const cleaned = raw.trim().replace(/\s/g, '').replace(',', '.')
  if (cleaned === '') return null
  const value = Number(cleaned)
  if (!Number.isFinite(value) || value < 0) return null
  return value
}
